<template>
  <div>
    <div class="details">
      <van-cell value="产品信息" class="bold" />
      <div class="van-hairline--bottom"></div>
      <div class="product-info">
        <p>名称：白发一族首乌套盒、绀发尊享套盒</p>
        <p>货号：{{ goods.code }}</p>
      </div>
      <div class="van-hairline--bottom"></div>
    </div>
    <div class="details-a">
      <van-cell value="产品归属" class="bold" />
      <div class="van-hairline--bottom"></div>
      <van-cell-group>
        <van-cell title="归属公司" value="广东绀发生物科技有限公司" />
        <van-cell title="是否正品" value="正品" />
      </van-cell-group>
    </div>
    <div class="details-search">
      <van-cell value="输入防伪密码" class="bold" />
      <van-search
        v-model="fwCode"
        show-action
        placeholder="请输入防伪密码"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">查询</div>
        </template>
      </van-search>
      <div class="search-msg">
        <h3 class="h3">验证提示</h3>
        <div class="van-hairline--bottom"></div>
        <div class="search-m search-m-t">
          <div class="search-m-l"><van-icon name="checked" /></div>
          <div class="search-m-r">
            <p class="p-1">正确查询</p>
            <p>即您所购买的商品为正品</p>
          </div>
        </div>
        <div class="search-m">
          <div class="search-m-l search-m-l-t"><van-icon name="clear" /></div>
          <div class="search-m-r">
            <p class="p-1">错误查询</p>
            <p>即验证码不存在，您所购买的产品未经官方验证</p>
          </div>
        </div>
      </div>
    </div>
    <wxNoShare />
  </div>
</template>

<script>
  import { Cell, CellGroup, Search,Icon } from 'vant'
  import jsonp from 'jsonp'

  export default {
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Search.name]: Search,
      [Icon.name]: Icon
    },
    name: 'retails',
    data() {
      return {
        fwCode: '',
        code: '',
        goods: null
      }
    },
    created() {
      this.code = this.$route.query.code
      this.getData()
    },
    methods: {
      getData() {
        this.$api.get('fw/details', {code: this.code}, r=>{
          this.goods = r.result
        })
      },
      onSearch(val) {
        if(this.fwCode === '') {
          this.$toast('请输入防伪密码')
          return
        }
        if(this.fwCode.length < 10) {
          this.$toast('防伪码长度不能少于10位')
          return
        }
        if(this.fwCode.length > 24) {
          this.$toast('防伪码长度不能大于24位')
          return
        }
        let regNumber = /^[0-9]*[1-9][0-9]*$/
        if(!regNumber.test(this.fwCode)) {
          this.$toast('您输入的防伪码不是数字')
          return
        }
        jsonp('http://www.hy2315.com/fwqueryjson.ashx?fwcode='+this.fwCode, null, (err, data) => {
          console.log(data)
          this.$toast(data.QueryResult)
        })
      }
    }
  }
</script>

<style scoped>
  .bold{
    font-weight: bold;
  }
  .details{
    background: #ffffff;
    overflow: hidden;
  }
  .product-info{
    padding:3%;
    font-size: 14px;
  }
  .details-a, .details-search{
    margin-top: 10px;
    background: #ffffff;
    overflow: hidden;
  }
  .search-msg{
    overflow: hidden;
  }
  .search-msg .h3{
    text-align: center;
    font-size: 14px;
    color:#1989fa;
  }
  .search-m{
    padding: 20px 0;
    overflow: hidden;
  }
  .search-m-t{
    padding-bottom: 0;
  }
  .search-m .search-m-l{
    width: 25%;
    text-align: center;
    font-size: 25px;
    color:#6ACA39;
    float: left;
  }
  .search-m .search-m-l-t{
    color:#EB5047;
  }
  .search-m .search-m-r{
    width: 70%;
    float: left;
  }
  .search-m .search-m-r p{
    font-size: 14px;
    margin: 0;
    color:#969799;
  }
  .search-m .search-m-r .p-1{
    margin-bottom: 5px;
    font-weight: bold;
    color:#1989fa;
  }
</style>



// WEBPACK FOOTER //
// src/views/data/details.vue